import type { FC } from 'react';

import { SkeletonBlock } from '../ui/SkeletonBlock';

import { PostActionsSkeleton } from './_components/PostActionsSkeleton';
import { PostAuthorHeaderSkeleton } from './_components/PostAuthorHeaderSkeleton';

export const PostCardSkeleton: FC = () => (
  <article className="border border-black/10 rounded-3xl w-full" aria-busy="true">
    {/* Header */}
    <div className="flex items-center gap-6 pt-4 px-4 animate-pulse">
      <PostAuthorHeaderSkeleton />
    </div>

    {/* Body */}
    <div className="flex flex-col gap-[23px] px-4 pt-7 animate-pulse">
      <SkeletonBlock className="w-[334px] max-w-full h-[33px]" />
      <div className="flex flex-col gap-2 pb-4">
        <SkeletonBlock className="w-[597px] max-w-full h-4" />
        <SkeletonBlock className="w-full h-4" />
        <SkeletonBlock className="w-[597px] max-w-full h-4" />
        <SkeletonBlock className="w-full h-4" />
        <SkeletonBlock className="w-[597px] max-w-full h-4" />
        <SkeletonBlock className="w-full h-4" />
        <SkeletonBlock className="w-[258px] max-w-full h-4" />
      </div>
    </div>

    {/* Actions */}
    <PostActionsSkeleton />
  </article>
);
